import { supabase } from '../lib/supabase';
import type { ServiceResult } from '../types/licensingRegistration';

export interface MLInvitation {
  id: string;
  token: string;
  email: string;
  cooperative_name: string;
  parliament_id: number;
  status: 'pending' | 'sent' | 'viewed' | 'registered' | 'expired' | 'cancelled';
  created_at: string;
  sent_at?: string;
  viewed_at?: string;
  registered_at?: string;
  expires_at: string;
  master_licensee_id?: string;
}

export class MLInvitationService {
  static async getInvitationByToken(token: string): Promise<ServiceResult<MLInvitation>> {
    try {
      const { data, error } = await supabase
        .rpc('get_ml_invitation_by_token', { p_token: token });

      if (error || !data) {
        return { success: false, error: 'Invalid invitation' };
      }

      return { success: true, data: data as MLInvitation };
    } catch (err) {
      return { success: false, error: err instanceof Error ? err.message : 'Unknown error' };
    }
  }

  static async validateToken(token: string): Promise<ServiceResult<MLInvitation>> {
    try {
      const { data, error } = await supabase
        .rpc('validate_ml_invitation', { p_token: token });

      if (error || !data) {
        return { success: false, error: 'Invalid or expired invitation' };
      }

      return { success: true, data: data as MLInvitation };
    } catch (err) {
      return { success: false, error: err instanceof Error ? err.message : 'Unknown error' };
    }
  }

  static async markAsViewed(token: string): Promise<ServiceResult<void>> {
    try {
      const { error } = await supabase
        .rpc('mark_ml_invitation_viewed', { p_token: token });

      if (error) {
        return { success: false, error: error.message };
      }

      return { success: true };
    } catch (err) {
      return { success: false, error: err instanceof Error ? err.message : 'Unknown error' };
    }
  }

  static async linkToMasterLicensee(token: string, masterLicenseeId: string): Promise<ServiceResult<void>> {
    try {
      const { error } = await supabase
        .rpc('link_invitation_to_master_licensee', { p_token: token, p_master_licensee_id: masterLicenseeId });

      if (error) {
        return { success: false, error: error.message };
      }

      return { success: true };
    } catch (err) {
      return { success: false, error: err instanceof Error ? err.message : 'Unknown error' };
    }
  }
}

export const mlInvitationService = new MLInvitationService();
